import _defineProperty from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function stringifyAttribute(name, value) {
  if (!value) {
    return '';
  }
  var stringified = '; ' + name;
  if (value === true) {
    return stringified; // boolean attributes shouldn't have a value
  }

  return stringified + '=' + value;
}
function stringifyAttributes(attributes) {
  if (typeof attributes.expires === 'number') {
    var milliseconds = Math.min(Date.now() + attributes.expires * 864e+5, 864e+13);
    attributes.expires = new Date(milliseconds);
  }
  return stringifyAttribute('Expires', attributes.expires ? attributes.expires.toUTCString() : '') + stringifyAttribute('Domain', attributes.domain) + stringifyAttribute('Path', attributes.path) + stringifyAttribute('Secure', attributes.secure) + stringifyAttribute('Partitioned', attributes.partitioned) + stringifyAttribute('SameSite', attributes.sameSite);
}
export function encode(name, value, attributes) {
  return encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent) // allowed special characters
  .replace(/\(/g, '%28').replace(/\)/g, '%29') // replace opening and closing parens
  + '=' + encodeURIComponent(value)
  // allowed special characters
  .replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent) + stringifyAttributes(attributes);
}
export function parse(cookieString) {
  var result = {};
  var cookies = cookieString ? cookieString.split('; ') : [];
  var _iterator = _createForOfIteratorHelper(cookies),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cookie = _step.value;
      var parts = cookie.split('=');
      var value = parts.slice(1).join('=');
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      try {
        var name = decodeURIComponent(parts[0]);
        result[name] = value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      } catch (e) {
        // ignore cookies with invalid name/value encoding
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
}
export function getAll() {
  return parse(document.cookie);
}
export function get(name) {
  return getAll()[name];
}
export function set(name, value, attributes) {
  document.cookie = encode(name, value, _objectSpread({
    path: '/'
  }, attributes));
}
export function remove(name, attributes) {
  set(name, '', _objectSpread(_objectSpread({}, attributes), {}, {
    expires: -1
  }));
}